import React, { Component, Suspense } from "react";
import axios from "axios";
import _ from "lodash";
import { Button, Row } from "reactstrap";
import {
  Segment,
  Sidebar,
  Pagination,
  Dropdown,
} from "semantic-ui-react";
import { connect } from "react-redux";
import ContentWrapper from "../../../template/Layout/ContentWrapper";
import { Link } from "react-router-dom";
import Loader from "../../../Global/Loader";
import { withRouter } from "react-router-dom";
import { DatePicker } from "antd";
import moment from "moment";
import { Services } from "../../../../repositories/clients/Services";
import FormFiltros from "../model/form";
import FormFiltrosDispach from "../model/formDispach";
import queryString from "query-string";
import "../styles.scss";
import "../Components/styles/cards.scss";
import { withNamespaces } from "react-i18next";
import Cards from "../../Components/Cards";
const Map = React.lazy(() => import("../../Components//Maps/map"));

const { RangePicker } = DatePicker;

class Receive extends Component {
  state = {
    isMovil: false,
    searching: "0",
    rolId: this.props._rolId,
    userId: this.props._user,
    rowid: "",
    extraElement: false,
    respladoCatalogCombo: {},

    map: (
      <Suspense fallback={<div>Loading...</div>}>
        <Map
          polylineData={[]}
          heidIcon={20}
          disableDefaultUI={true}
          // style={{ maxHeight: "300px" }}
          marker={[]}
          visible={true}
          type={"polyline"}
          data={[]}
          dataDrawer={""}
          // zoom={3}
        />
      </Suspense>
    ),
    // clientesSelect: clientSave.getAuthentication('client'),
    clientesSelect: this.props.clients
      ? JSON.stringify(this.props.clients)
      : "[0]",
    activePage: 1,
    limit: 10,
    catalogCombo: [],
    paramsxml: {},
    numberPage: 1,
    totalPages: 1,
    pages: 0,
    numberPageOrder: 1,
    activePageOrder: 1,
    totalPagesOrder: 1,
    searchOrder: "",
    isSearchsearchOrder: false,
    excelOrderLoading: false,
    limitOrder: 10,
    pagesOrder: 0,
    totalPagesExt: 1,
    search: "",
    isSearch: false,
    excelShipmentLoading: false,
    totalCard: [],
    dataDrawer: "",
    visible: false,
    selected: "",
    polyline: [],
    data: [],
    dataTable: [],
    // dataMap: mapJson.dataMap,
    dataAux: [],
    activePageAux: 1,
    dataOut: [],
    labelSelected: "",
    loading: true,
    graphs: [],
    markers: [],
    dataMap: [],
    donutChart: [],
    extraFilter: "",
    priorityChecked: false,

    /*
    "Status":null,
         "rowNum":1,
         "Progress":0,
         "Received":null,
         "Released":null,
         "StatusId":null,
         "Consignee":"Onboard Logistics USA Inc",
         "Consignor":"Onboard Logistics USA Inc",
         "Warehouse":"MIA",
         "ConsigneeId":237234,
         "ConsignorId":237234,
         "Destination":null,
         "Observation":"1Z6658080334115957",
         "ReferenceNo":"119133512",
         "TransactionNo":"RC00128110",
         "TransportModeId":null
         */
    config: [
      {
        title: this.props.t("status"),
        idExcel: "Status",
        xls: true,
        header: { link: false, hide: true, icon: false },
        data: {
          link: false,
          progress: false,
          icon: "icon-warehouse-solid-2",
          status: false,
          hide: true,
        },
        id: "null",
        className: "hidden",
      },
      {
        title: "",
        xls: false,
        first: true,
        foot: { show: false, style: { fontSize: "12px", fontWeight: "bold" } },
        header: { link: false, hide: true, icon: false },
        data: { link: false, progress: false, icon: false, status: false },
        id: "rowNum",
        link: "/intransit",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("receive_rcn_no"),
        xls: true,
        foot: {
          show: false,
          style: { fontSize: "12px", fontWeight: "bold", color: "green" },
        },
        data: {
          link: false,
          progress: false,
          icon: false,
          status: false,
          custom: true,
        },
        header: { link: false, validateEvents: false },
        id: "TransactionNo",
        custom: (value) => (
          <div class="mb-mail-from">
            <center>
              <Link
                className="linkDetail"
                to={"/warehousingDetail/receive/" + value.TransitsId}
              >
                {value.TransactionNo}
              </Link>
            </center>
          </div>
        ),
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },

      {
        title: this.props.t("receive_consignor"),
        xls: true,
        icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
        colorLogo: "#643296c2",
        id: "Consignor",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
        limitText: 25,
      },
      {
        title: this.props.t("receive_consignee"),
        xls: true,
        colorLogo: "#643296c2",
        id: "Consignee",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
        limitText: 25,
      },
      {
        title: this.props.t("dispatch_warehouse"),
        xls: true,
        id: "Warehouse",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
        limitText: 15,
      },
      {
        title: this.props.t("dispatch_rcn_reference_no"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        id: "ReferenceNo",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
      },

      {
        title: this.props.t("dispatch_observation"),
        xls: true,
        id: "Observation",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("dispatch_received"),
        xls: true,
        id: "Received",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("dispatch"),
        xls: true,
        id: "Released",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
    ],

    configDispach: [
      {
        title: this.props.t("status"),
        idExcel: "Status",
        xls: true,
        header: { link: false, hide: true, icon: false },
        data: {
          link: false,
          progress: false,
          icon: false,
          status: false,
          hide: true,
        },
        id: "null",
        className: "hidden",
      },
      {
        title: "",
        xls: false,
        first: true,
        foot: { show: false, style: { fontSize: "12px", fontWeight: "bold" } },
        header: { link: false, hide: true, icon: false },
        data: { link: false, progress: false, icon: false, status: false },
        id: "ShipmentId",
        link: "/",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("receive_dcn_no"),
        xls: true,
        foot: {
          show: false,
          style: { fontSize: "12px", fontWeight: "bold", color: "green" },
        },
        data: {
          link: false,
          progress: false,
          icon: false,
          status: false,
          custom: true,
        },
        header: { link: false, validateEvents: false },
        id: "ShipmentNumber",
        custom: (value) => (
          <div class="mb-mail-from">
            <center>
              <Link
                className="linkDetail"
                to={"/shipmentsDetail/" + value.ShipmentId}
              >
                {value.ShipmentNumber}
              </Link>
            </center>
          </div>
        ),
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },

      {
        title: this.props.t("receive_consignor"),
        xls: true,
        icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
        colorLogo: "#643296c2",
        id: "CustomerName",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
        limitText: 30,
      },
      {
        title: this.props.t("receive_consignee"),
        xls: true,
        colorLogo: "#643296c2",
        id: "ShipperName",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
        limitText: 25,
      },
      {
        title: this.props.t("receive_destination"),
        xls: true,
        id: "ConsigneeName",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
        limitText: 15,
      },
      {
        title: this.props.t("receive_dcn_reference_no"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        id: "CustomertRef",
        className: "col-xs-3 col-md-2 col-lg-2 p-0",
      },

      {
        title: this.props.t("receive_transport"),
        xls: true,
        id: "Containers",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
      {
        title: this.props.t("dispatch"),
        xls: true,
        id: "dispatch",
        className: "col-xs-3 col-md-2 col-lg-1 p-0",
      },
    ],

    advancedSearch2: FormFiltros,
    advancedSearch: [],
    advancedObj: [],
    advancedOrderObj: [],
    url: "",
    totalShipments: "",
    advancedSearchDispach: FormFiltrosDispach,
  };

  componentDidMount = () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMovil: isMobileDevice,
    });
    let objSearch = queryString.parse(this.props.location.search);
    let searching = objSearch.searching ? objSearch.searching : "0";

    this.setState({ searching }, () => {
      this.getListShipments();
      this.getCatalogs();
      this.resetAdvance();
    });
    window.addEventListener("resize", () => {
      let newGraphs = this.state.graphs;
      newGraphs.map((e) => {
        e.width = this.calculateWidth();
        return e;
      });
      this.setState({ graphs: newGraphs });
    });
  };

  getCatalogs = () => {
    let data = {
      client: this.state.clientesSelect,
      userId: this.props._user,
      lang: this.props.lng,
    };
    axios
      .post(
        `${Services.WAREHOUSE.path}intransit/catalogShipment/TransitReceive`,
        data,
      )
      .then((success) => {
        let catalogCombo = success.data.data;
        if (catalogCombo["CatEventos"]) {
          catalogCombo["CatEventos"].forEach((ev) => {
            if (ev.key !== "0") {
              ev.icon = (
                <img
                  className="_imgdropdown"
                  height="20px"
                  width="20px"
                  src={
                    "https://magiclog.blob.core.windows.net/onboardpic/warning.png"
                  }
                  alt="img_drop"
                />
              );
            }
          });
        }
        this.setState(
          {
            catalogCombo,
          },
          () => {
            this.generateFilters();
            this.generateFiltersDispach();
          },
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  getListShipments = () => {
    let { searching } = this.state;
    let eventSearch = {};
    let advanced = this.state.advancedObj;
    this.setState({
      fullLoader: false,
    });

    if (searching !== "0") {
      eventSearch = this.getEventObject(searching);
      if (eventSearch) advanced = [...advanced, eventSearch];
    }
    let hasFilters =
      searching !== "0" ||
      advanced.some((item) => {
        if (Array.isArray(item.value)) return item.value.length > 0;
        return (
          item.value !== undefined && item.value !== null && item.value !== ""
        );
      });
    let data = {
      client: this.state.clientesSelect,
      pag: this.state.numberPage,
      limit: this.state.limit,
      lang: this.props.lng,
      userId: this.state.userId,
      EsDTA: 0,
      search: this.state.search,
      advanced,
    };
    this.setState({
      url: encodeURI(
        `${Services.WAREHOUSE.path}intransit/listShipments/TransitReceive?search=${this.state.search}&limit=1000`,
      ),
      paramsxml: data,
    });
    // // axios.post(`${Services.Get_Traceability_Shipments.path}shipments/listShipments`, data, {params:{pag:this.state.numberPage,limit:this.state.limit, EsDTA:0, search: this.state.search}} ).then(success => {
    axios
      .post(
        `${Services.WAREHOUSE.path}intransit/listShipments/TransitReceive`,
        data,
      )
      .then((success) => {
        let data = success.data.data.map((e) => {
          let TraspormodeId = 1;
          e.TraspormodeId = TraspormodeId;
          e.id = e.ShipmentNumber;
          return e;
        });
        this.setState({
          totalPages: success.data.totalPage,
          totalPagesExt: success.data.totalPage,
          data: data,
          dataAux: data,
          dataOut: data,
          fullLoader: true,
          totalShipments: (
            <>
              {" "}
              {success.data.data.length !== 0 ? (
                <b>
                  {this.currencyFormatter({
                    currency: "USD",
                    value: success.data.completed,
                  })}{" "}
                  of{" "}
                  {this.currencyFormatter({
                    currency: "USD",
                    value: hasFilters
                      ? success.data.total
                      : success.data.completed,
                  })}{" "}
                  results
                </b>
              ) : (
                ""
              )}
            </>
          ),
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  currencyFormatter({ currency, value }) {
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
    });
    return formatter.format(value);
  }

  setAdvanced = (val) => {
    this.setState({ advancedObj: val }, () => {
      this.getListShipments();
    });
  };

  changePage = (activePage) => {
    console.log("activePageOrder", activePage);
    this.setState(
      {
        fullLoader: false,
        numberPage: activePage,
        activePageAux: activePage,
        activePage: activePage,
      },
      () => {
        this.getListShipments();
      },
    );
  };

  handleChange = () => (event) => {
    let val = event.target.value;
    if (!this.state.isSearch) {
      this.setState({ isSearch: true }, () => {
        this.setState(
          {
            search: val,
            activePage: 1,
            activePageAux: 1,
            limit: 10,
            numberPage: 1,
            totalPages: 1,
          },
          () => {
            this.getListShipments();
          },
        );
      });
    }
  };

  newSearch = (val) => {
    if (val.length < 1) {
      this.setState(
        {
          search: val,
          isSearch: false,
          activePage: 1,
          activePageAux: 1,
          limit: 10,
          numberPage: 1,
          totalPages: 1,
        },
        () => {
          this.getListShipments();
        },
      );
    } else {
      if (val.length < this.state.search.length) {
        this.setState(
          {
            search: val,
            activePage: 1,
            activePageAux: 1,
            limit: 10,
            numberPage: 1,
            totalPages: 1,
          },
          () => {
            this.getListShipments();
          },
        );
      } else {
        this.setState({ search: val }, () => {
          this.getListShipments();
        });
      }
    }
  };

  calculateWidth = () => {
    if (window.innerWidth >= 1756) {
      return (window.innerWidth / 4.8).toString();
    } else {
      return (window.innerWidth / 5.5).toString();
    }
  };

  handleSelectedFile = (value) => {
    try {
      let out = this.searchSelected(value);
      this.setState({
        selected: value,
        data: [out],
        dataOut: [out],
        labelSelected: value,
        activePage: 1,
        totalPages: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  searchSelected = (ID) => {
    let { dataAux } = this.state;
    let FOUND = dataAux.find((o) => o.id === ID);
    return FOUND;
  };
  toggleDrawerMap = (data) => (evt) => {
    if (evt) evt.preventDefault();

    this.handleSelectedFile(data.id);
    this.setState({ visible: true, dataDrawer: data }, () => {
      this.setState({
        map: (
          <Suspense fallback={<div>Loading...</div>}>
            <Map
              polylineData={this.state.polylineData}
              heidIcon={20}
              style={{ maxHeight: "300px" }}
              marker={this.state.markers}
              visible={true}
              type={"polylineDrawer"}
              data={this.state.polylineData}
              dataDrawer={this.state.dataDrawer}
              zoom={3}
            />
          </Suspense>
        ),
      });
    });
  };

  redirectTo = (id) => (evt) => {
    // evt.preventDefault();
    // this.props.history.push('/tracking/'+id)
  };

  resetTableCards = (evt) => {
    evt.preventDefault();
    let { dataAux, totalPagesExt, activePageAux } = this.state;
    this.setState(
      {
        data: _.cloneDeep(dataAux),
        dataOut: _.cloneDeep(dataAux),
        labelSelected: "",
        activePage: activePageAux,
        totalPages: totalPagesExt,
        dataDrawer: "",
      },
      () => {
        this.setState({
          map: (
            <Suspense fallback={<div>Loading...</div>}>
              <Map
                polylineData={this.state.polylineData}
                heidIcon={20}
                style={{ maxHeight: "300px" }}
                marker={this.state.markers}
                visible={true}
                type={"polylineDrawer"}
                data={this.state.polylineData}
                dataDrawer={this.state.dataDrawer}
                zoom={3}
                showDrawerInfo={false}
              />
            </Suspense>
          ),
        });
      },
    );
  };

  backres = (backResponse) => {
    this.setState({
      data: backResponse,
      dataAux: backResponse,
      dataOut: backResponse,
    });
  };
  resetAdvance = () => {
    let { advancedSearch2 } = this.state;
    advancedSearch2.forEach((advData) => {
      advData.values = [];
    });
    this.setState({ advancedSearch2 }, () => {
      this.findAdvanced();
      this.generateFilters();
      this.generateFiltersDispach();
    });
  };

  generateFilters = (newCat) => {
    const { advancedSearch2, catalogCombo } = this.state;
    let Inputs = advancedSearch2.map((e, i) => {
      if (e.type === "Datetime")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <RangePicker
              className="col-md-12"
              placeholder={[
                this.props.t("start_date"),
                this.props.t("end_date"),
              ]}
              value={
                Array.isArray(e.values)
                  ? e.values.length > 0
                    ? [
                        moment.utc(new Date(e.values[0].init)),
                        moment.utc(new Date(e.values[0].end)),
                      ]
                    : []
                  : []
              }
              style={{
                height: "36px",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
                // fontSize:'12px'
              }}
              id={e.id}
              onChange={this.handleChangeDatePicKer(e.id)}
              size="large"
              format={e.format}
            />
          </div>
        );
      else if (e.type === "multipleSelect")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <Dropdown
              className="NewClass"
              onChange={(evt, { value }) =>
                this.handleChangeSelectMultiple(e.id, value)
              }
              id={e.id}
              options={catalogCombo[e.options]}
              clearable
              search
              selection
              floating
              fluid
              value={e.values}
              multiple
              allowAdditions
              upward={false}
            />
          </div>
        );
      return null;
    });
    let NewInput = (
      <div>
        <div className="d-flex justify-content-end">
          <Button
            className="mr-3"
            onClick={this.findAdvanced}
            color="primary"
            style={{ width: "auto" }}
            title={this.props.t("apply_filter")}
          >
            {this.props.t("apply")}
          </Button>
          <em
            class="fa-2x mr-2 fas fa-eraser"
            style={{
              color: "#085fb0",

              cursor: "pointer",
            }}
            title={this.props.t("remove_filters")}
            onClick={this.resetAdvance}
          />
        </div>

        <div className="row">{Inputs}</div>
      </div>
    );

    this.setState({
      filtros: NewInput,
    });
  };

  generateFiltersDispach = (newCat) => {
    const { advancedSearchDispach, catalogCombo } = this.state;
    let Inputs = advancedSearchDispach.map((e, i) => {
      if (e.type === "Datetime")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <RangePicker
              className="col-md-12"
              placeholder={[
                this.props.t("start_date"),
                this.props.t("end_date"),
              ]}
              value={
                Array.isArray(e.values)
                  ? e.values.length > 0
                    ? [
                        moment.utc(new Date(e.values[0].init)),
                        moment.utc(new Date(e.values[0].end)),
                      ]
                    : []
                  : []
              }
              style={{
                height: "36px",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
                // fontSize:'12px'
              }}
              id={e.id}
              onChange={this.handleChangeDatePicKer(e.id)}
              size="large"
              format={e.format}
            />
          </div>
        );
      else if (e.type === "multipleSelect")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <Dropdown
              className="NewClass"
              onChange={(evt, { value }) =>
                this.handleChangeSelectMultiple(e.id, value)
              }
              id={e.id}
              options={catalogCombo[e.options]}
              clearable
              search
              selection
              floating
              fluid
              value={e.values}
              multiple
              allowAdditions
              dupward={false}
            />
          </div>
        );
      return null;
    });
    let NewInput = (
      <div>
        <div className="d-flex justify-content-end">
          <Button
            className="mr-3"
            onClick={this.findAdvanced}
            color="primary"
            style={{ width: "auto" }}
            title={this.props.t("apply_filter")}
          >
            {this.props.t("apply")}
          </Button>
          <em
            class="fa-2x mr-2 fas fa-eraser"
            style={{
              color: "#085fb0",

              cursor: "pointer",
            }}
            title={this.props.t("remove_filters")}
            onClick={this.resetAdvance}
          />
        </div>

        <div className="row">{Inputs}</div>
      </div>
    );

    this.setState({
      filtrosDispach: NewInput,
    });
  };

  handleChangeSelectMultiple = (id, value) => {
    let { advancedSearch2 } = this.state;
    for (let i = 0; i < advancedSearch2.length; i++) {
      const e = advancedSearch2[i];
      if (e.id === id) {
        e.values = value;
      }
    }

    this.setState({ advancedSearch2 }, () => {
      this.generateFilters();
      this.generateFiltersDispach();
      // this.findAdvanced();
    });
  };

  handleChangeDatePicKer = (name) => (event) => {
    let { advancedSearch2 } = this.state;

    try {
      if (event) {
        advancedSearch2.forEach((search) => {
          if (search.id === name) {
            search.values = [
              {
                init: event[0].format("YYYY-MM-DD"),
                end: event[1].format("YYYY-MM-DD"),
              },
            ];
          }
        });
        this.setState({ advancedSearch2 }, () => {
          this.generateFilters();
          this.generateFiltersDispach();
          // this.findAdvanced();
        });
      } else {
        advancedSearch2.forEach((search) => {
          if (search.id === name) {
            search.values = [];
          }
        });
        this.setState({ advancedSearch2 }, () => {
          this.generateFilters();
          this.generateFiltersDispach();
          // this.findAdvanced();
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  findAdvanced = () => {
    let obj = [];
    this.state.advancedSearch2.forEach((e) => {
      if (e.values && e.values.length > 0) {
        let newPush = {
          id: e.id2,
          UseIN: true,
          isDate: e.type === "Datetime" ? true : false,
          value: e.values,
        };
        obj.push(newPush);
      } else {
        obj.push({
          id: e.id,
          UseIN: false,
          value: e.value,
        });
      }
    });
    this.setState(
      {
        advancedObj: obj,
        numberPage: 1,
        activePage: 1,
        activePageAux: 1,
      },
      () => {
        this.getListShipments();
      },
    );
  };

  generateShipmentExcel = () => {
    this.setState({
      excelShipmentLoading: true,
    });

    let data = {
      client: this.state.clientesSelect,
      pag: "",
      lang: this.props.lng,
      userId: this.state.userId,
      limit: "",
      EsDTA: 0,
      search: this.state.search,
      advanced: this.state.advancedObj,
      allData: true,
    };

    this.setState({
      url: encodeURI(
        `${Services.WAREHOUSE.path}intransit/listShipments/TransitReceive?search=${this.state.search}&allData=true`,
      ),
      paramsxml: data,
    });
  };

  setShipmentSearch = (name, value) => {
    this.setState(
      {
        search: value,
        activePage: 1,
        activePageAux: 1,
        numberPage: 1,
      },
      () => {
        this.getListShipments();
      },
    );
  };

  loadTab = (evt) => {};

  render() {
    let { fullLoader, totalShipments, data } = this.state;

    return (
      <ContentWrapper>
        <Loader hidden={fullLoader}></Loader>

        <Row>
          <div className="col-12 p-0">
            <Suspense fallback={<div>Loading...</div>}>
              <Sidebar.Pushable
                as={Segment}
                className="listado-trazabilidad"
                style={{ border: "none", boxShadow: "none" }}
              >
                <Sidebar.Pusher>
                  <Segment basic>
                    <Cards
                      paramsxml={this.state.paramsxml}
                      generateShipmentExcel={this.generateShipmentExcel}
                      clientesSelect={this.state.clientesSelect}
                      advancedSearch={(val) => {
                        this.setAdvanced(val);
                      }}
                      advancedSearchData={this.state.advancedSearch}
                      urlReport={this.state.url}
                      newSearch={(value) => {
                        this.newSearch(value);
                      }}
                      panel={true}
                      onlyShow={true}
                      filtrosPanel={this.state.filtros}
                      resetAdvance={() => {
                        this.resetAdvance();
                      }}
                      pagination={false}
                      broswer={true}
                      config={this.state.config}
                      headerCard={this.state.headerCard}
                      toggleDrawer={this.toggleDrawerMap}
                      visible={this.state.visible}
                      data={this.state.dataOut}
                      dataSearch={this.state.data}
                      reset={this.resetTableCards}
                      labelStatus={this.state.labelSelected}
                      backRes={this.backres}
                      xlsxConf={{
                        nameXlsx: `${
                          this.props.t("receive") +
                          "-" +
                          moment(new Date()).format("YYYYMMDD") +
                          ".xlsx"
                        }`,

                        sheetName: this.props.t("receive"),
                      }}
                      totalShipments={totalShipments}
                    ></Cards>
                  </Segment>
                  {/* </div> */}
                  {data[0] ? (
                    data[0].total !== "0" ? (
                      <div className="col-12">
                        <center>
                          <Pagination
                            ellipsisItem={null}
                            activePage={this.state.activePage}
                            siblingRange={0}
                            size={"mini"}
                            // size={window.innerWidth < 993 ? 'mini' : ''}
                            // firstItem={null}
                            // lastItem={null}
                            // pointing
                            // secondary
                            totalPages={this.state.totalPages}
                            onPageChange={(e, { activePage }) => {
                              this.changePage(activePage);
                            }}
                          />
                        </center>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </Sidebar.Pusher>
              </Sidebar.Pushable>
            </Suspense>
          </div>
        </Row>

        {/* </Col> */}
      </ContentWrapper>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Receive)),
);
